<template>
  <div class="invoice-entry" :class="{ 'cursor-pointer': !preview && work_package.name !== 'Sum'}">
    <div class="invoice-entry-header">
      <div class ="invoice-70" @click="handleEntryClick()">{{ work_package.name }} <span v-if="work_package.name !== 'Sum'">[{{ work_package.twork_package.id }}]</span></div>
      <div class="invoice-10 invoice-text-right" v-if="work_package.name !== 'Sum'">0%</div>
      <div class="invoice-20 invoice-text-right">{{ calcPrice(work_package) }} &euro;</div>
    </div>
    <div v-if="preview" class="invoice-entry-content">
      <div v-for="work_step in work_package.work_steps" :key="work_step.id">
        {{ work_step.text }}
      </div>
      <div v-for="cost_step in work_package.cost_steps" :key="cost_step.id" class="cost-step">
        <div>
          + {{ cost_step.text }}
        </div>
        <div>
          {{ cost_step.cost }} &euro;
        </div>
      </div>
    </div>
    <div v-else class="invoice-entry-content">
      <div v-for="work_step in work_package.iwork_steps" :key="work_step.id">
        {{ work_step.text }}
      </div>
      <div v-for="cost_step in work_package.icost_steps" :key="cost_step.id" class="cost-step">
        <div>
          + {{ cost_step.text }}
        </div>
        <div>
          {{ cost_step.cost }} &euro;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['work_package', 'preview'],
  methods: {
    calcPrice(wp){
      if (this.preview) {
        if (this.work_package.name === 'Sum') {
          return wp.costs_tendered_total;
        } else {
          switch (this.work_package.cost_strategy.id) {
            case 1:
              // 'Flat Rate'
              return wp.costs_tendered_total;
            case 2:
              // 'Unit Price'
              return wp.costs_tendered_material * wp.quantity_value;
            case 3:
              // 'Hourly Wages'
              return (wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour;
            case 4:
              // 'Material Price'
              return wp.costs_tendered_material;
            case 5:
              // 'Material Price and Hourly Wages'
              return ((wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour) + wp.costs_tendered_material;
            default:
              return 0;
          }
        }
      } else {
        return wp.costs_total;
      }
    },
    handleEntryClick(){
      if (!this.preview && this.work_package.name !== 'Sum') {
        this.$router.push({ name: 'TaktPlanWorkPackageInfo', params: {
            project_id: this.work_package.twork_package.project_id,
            train_id: this.work_package.twork_package.train_id,
            taktarea_id: this.work_package.twork_package.taktarea_id,
            twaggon_id: this.work_package.twork_package.twaggon_id,
            tworkpackage_id: this.work_package.twork_package.id,
          } });
      }
    }
  }
}
</script>

<style lang="css" scoped>

.invoice-entry {
  background-color: #f5f5f5;
  padding: 5px;
  margin-bottom: 2px;
}

.invoice-entry-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  width: 100%
}

.invoice-70 {
  width: 70%;
}

.invoice-20 {
  width: 20%;
}

.invoice-10 {
  width: 10%;
}

.invoice-text-right {
  text-align: right;
}

.cost-step {
  display: flex;
  justify-content: space-between;
}

.invoice-entry-content {
  /* font-size: 6mm; */
}


</style>
